import { render, staticRenderFns } from "./FieldsMap.vue?vue&type=template&id=c60c0d8a&scoped=true&"
import script from "./FieldsMap.vue?vue&type=script&lang=ts&"
export * from "./FieldsMap.vue?vue&type=script&lang=ts&"
import style0 from "./FieldsMap.vue?vue&type=style&index=0&id=c60c0d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60c0d8a",
  null
  
)

export default component.exports